import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4e22077a")
const _hoisted_1 = { id: "canvas-component" }
const _hoisted_2 = {
  key: 2,
  id: "main-canvas",
  ref: "canvasRef"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "show-icon-label-triangle" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " Bring to Front", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, " Bring Forward", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " Send Backwards", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " Send to Back", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollBar = _resolveComponent("ScrollBar")!
  const _component_AsyncLeftRuler = _resolveComponent("AsyncLeftRuler")!
  const _component_AsyncTopRuler = _resolveComponent("AsyncTopRuler")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ScrollBar),
    (_ctx.showRulers)
      ? (_openBlock(), _createBlock(_component_AsyncLeftRuler, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showRulers)
      ? (_openBlock(), _createBlock(_component_AsyncTopRuler, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.canvasWrapWidth > 0 && _ctx.canvasWrapHeight > 0)
      ? (_openBlock(), _createElementBlock("canvas", _hoisted_2, null, 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle({ visibility: _ctx.iconLabel ? 'visible' : 'hidden' }),
      ref: "iconLabelPlacementRef",
      id: "show-icon-label"
    }, [
      _createElementVNode("div", null, _toDisplayString(_ctx.iconLabel), 1),
      _hoisted_3
    ], 4),
    _createElementVNode("div", {
      style: _normalizeStyle({ display: _ctx.showStackPlacement ? 'flex' : 'none' }),
      ref: "stackPlacementRef",
      id: "stack-placement-wrap"
    }, [
      _createElementVNode("div", {
        class: "placement-cmd",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.arrangeStack('bring-to-front')))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "fast-backward",
          rotation: "90",
          "aria-hidden": "true"
        }),
        _hoisted_4
      ]),
      _createElementVNode("div", {
        class: "placement-cmd",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.arrangeStack('bring-forward')))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "backward",
          rotation: "90",
          "aria-hidden": "true"
        }),
        _hoisted_5
      ]),
      _createElementVNode("div", {
        class: "placement-cmd",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.arrangeStack('send-backwards')))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "backward",
          rotation: "270",
          "aria-hidden": "true"
        }),
        _hoisted_6
      ]),
      _createElementVNode("div", {
        class: "placement-cmd",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.arrangeStack('send-to-back')))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "fast-backward",
          rotation: "270",
          "aria-hidden": "true"
        }),
        _hoisted_7
      ])
    ], 4)
  ]))
}